export default "__VITE_ASSET__Bqp42Fh___"